/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosEnumSectionSizes, EmbedSectionFragment } from "@cosmos/hygraph-schema";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";

import {
	BackgroundContainer,
	ResponsiveContainer,
	SectionContainer,
	CosmosEmbed,
	SectionHeading,
} from "@components/elements";
import { Box, VStack } from "@panda/jsx";
import { cx } from "@panda/css";
import { smStyles, mdStyles, lgStyles } from "@components/styles/size.style";

export const EmbedSection = ({ config, size, embed }: EmbedSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(embed?.iframeSrc);
	if (!validHeading && !validContent) return null;
	const effectiveSize = size ?? CosmosEnumSectionSizes.Md;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack alignItems="stretch" gap="eds.dimension.56" className="embed-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<Box w="full">
								<Box
									className={cx(
										effectiveSize === CosmosEnumSectionSizes.Sm ? smStyles : null,
										effectiveSize === CosmosEnumSectionSizes.Md ? mdStyles : null,
										effectiveSize === CosmosEnumSectionSizes.Lg ? lgStyles : null,
									)}
									marginInline={config?.heading?.centeredVerticalStack ? "auto" : "unset"}
								>
									<CosmosEmbed {...embed} />
								</Box>
							</Box>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
